import * as React from "react";
import { singleton } from "logic/singleton";
const ParametersContext = React.createContext(void 0);
export default singleton("contexts.SearchFiltersParametersContext", () => ParametersContext);
